import { Skeleton } from '@genial/components';
import { Box } from 'native-base';
import { useMemo } from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../components/TableContent';

const createSkeleton = () => (
  <Skeleton width={40 + Math.random() * 50 + '%'} height="inset.xs" borderRadius="sm" />
);

export const DividendHistoryItemLoadingMobile = () => {
  const numLoadings = 10;
  const loadingContent = useMemo(
    () =>
      Array.from({ length: numLoadings }, (_, i) => i).map((row, rowIndex) => (
        <>
          <TableContentItemColumn
            key={rowIndex}
            flex={1}
            direction="row"
            justifyContent="space-between"
            width="full">
            <TableContentItemText flex={1}>{createSkeleton()}</TableContentItemText>
            <TableContentItemText flex={1}>{createSkeleton()}</TableContentItemText>
          </TableContentItemColumn>
          {rowIndex < numLoadings - 1 && (
            <Box
              key="spacer"
              borderBottomColor="neutral.lightest"
              borderBottomWidth="1px"
              paddingTop="inset.nano"
              marginBottom="inset.nano"
              width="full"
            />
          )}
        </>
      )),
    []
  );

  return (
    <TableContent direction="column" space={0} py="stack.xxs" px="inline.xxxs" spaceX="inline.xxxs">
      {loadingContent}
    </TableContent>
  );
};
